export const SITE_URL = 'https://www.marcosaquino.com'

export const legacyArticleSlugs: Record<string, string> = {
  "dextro-cloud-plataforma-iot-sem-amarras": "dextro-cloud-independent-iot-platform",
  "produto-conectado-do-prototipo-a-operacao": "connected-products-from-prototype-to-production",
  "gateway-iot-integracao-industrial": "industrial-iot-gateway-integration",
  "plataformas-web-operacoes-distribuidas": "web-platforms-distributed-operations"
}
